/**
 * Company → project hierarchy for Radix Select dropdowns.
 * Company names are non-selectable labels; projects are indented; a dashed
 * separator sits under each company's last project (except the final group).
 */

import { SelectGroup, SelectItem, SelectLabel, SelectSeparator } from "@/components/ui/select";

export type GroupedProjectOption = {
  id: string;
  name: string;
  companyName: string | null;
};

function groupByCompany(projects: GroupedProjectOption[]) {
  const map = new Map<string, { id: string; name: string }[]>();
  for (const project of projects) {
    const key = project.companyName || "—";
    const list = map.get(key) ?? [];
    list.push({ id: project.id, name: project.name });
    map.set(key, list);
  }
  return Array.from(map.entries());
}

export function GroupedProjectSelectItems({ projects }: { projects: GroupedProjectOption[] }) {
  const grouped = groupByCompany(projects);

  return (
    <>
      {grouped.map(([company, list], groupIndex) => {
        const isLastGroup = groupIndex === grouped.length - 1;
        return (
          <SelectGroup key={company}>
            <SelectLabel className="text-muted-foreground">{company}</SelectLabel>
            {list.map((project) => (
              <SelectItem key={project.id} value={project.id} className="pl-6">
                {project.name}
              </SelectItem>
            ))}
            {!isLastGroup ? (
              <SelectSeparator className="mx-2 my-1 h-0 bg-transparent border-t border-dashed border-border" />
            ) : null}
          </SelectGroup>
        );
      })}
    </>
  );
}
